import Select from 'react-select'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useListData, usePet, useToggle } from '../../modules'

import Modal from "../reusable/modal"

const NewStockTakeTally = ({ onPerform }) => {
    const [string, setString] = useState('')
    const [store, setStore] = useState(null)
    const [selected, setSelected] = useState([])

    const [visible, toggle] = useToggle(true)

    const [{ data }] = usePet('stores', { limit: 100 }, { notify: true })

    const hst = useHistory()

    const close = () => {
        toggle()
        setTimeout(() => hst.goBack(), 300)
    }

    const onComplete = ({ }, notif, ops) => {
        onPerform()
        notif('Date has been edited', ops('success'))

        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('createStockTakeTally', {
        store: store?.value,
        users: selected.map(user => user.value)
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Creating stock take...' } })

    const [
        { loading: uLoading, fetch },
        { list: users = [] }
    ] = useListData('users', { designation: 'All', string, limit: 50 }, { notify: true, manual: false })

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetch()
        }
    }

    return (
        <Modal
            w={400}
            title="New Stock Take Tally"
            toggle={close}
            visible={visible}>
            <div className="flex flex-wrap mt-3">
                <div className="w-full px-3 mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Select Store
                    </label>
                    <Select
                        value={store}
                        onChange={setStore}
                        placeholder="Select Store"
                        options={(data?.stores || []).map(store => ({ label: store.name, value: store._id }))} />
                </div>
                <div className="w-full px-3 my-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Select Users
                    </label>
                    <Select
                        isMulti
                        value={selected}
                        isLoading={uLoading}
                        onChange={setSelected}
                        onInputChange={search}
                        placeholder="Select Users"
                        options={users.map(user => ({ label: user.name, value: user._id }))} />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={loading} onClick={execute} type="submit" className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default NewStockTakeTally